import { useTranslation } from 'react-i18next';
import type { Failure } from './consent-format';
import styles from './ConsentTemplates.module.css';

/** An API failure in a consent drawer: staff wording, API message, requestId. */
export function FailureBox({ failure }: { failure: Failure }) {
  const { t } = useTranslation();
  return (
    <div className={styles.error} role="alert">
      {failure.title}
      {failure.detail && <span>{failure.detail}</span>}
      {failure.requestId && (
        <span>{t('common.requestId', { id: failure.requestId })}</span>
      )}
    </div>
  );
}
